import { render, staticRenderFns } from "./MyEduInfor.vue?vue&type=template&id=59d3a046&"
import script from "./MyEduInfor.vue?vue&type=script&lang=js&"
export * from "./MyEduInfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports